import { Box } from '@chakra-ui/react'

import { useOfferGrid } from '../../../context/OfferGridContext'
import { OfferSmeColumnSection } from './OfferSmeColumnSection'
import { SectionTitle } from './components/SectionTitle'

export const OfferSmeHeaderColumn = () => {
  const { openedColumns, onSectionTitleClick } = useOfferGrid()

  return (
    <Box sx={{ display: 'grid', gap: 'px', alignSelf: 'end' }}>
      {/* {insuranceGroups &&
        insuranceGroups.length > 0 &&
        insuranceGroups.map((section) => {
          return (
            <OfferSmeColumnSection
              key={section.id}
              id={section.id}
              title={section.title}
              // icon={section.icon}
              isOpened={openedColumns.includes(section.id)}
              onClick={() => onSectionTitleClick(section.id)}
              headerCells={section.insurances}
            />
          )
        })} */}

      <SectionTitle label="Sleva" />
      <SectionTitle label="Splátka" />
    </Box>
  )
}
